exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".HTtFX,.nDIpp{font-weight:700}.nDIpp{display:-webkit-box;display:-ms-flexbox;display:flex;font-size:15px;margin-left:20px;margin-bottom:27px}.nDIpp img{width:25px;height:25px;margin-right:10px}.nDIpp div{padding-top:6px}._2kIB-,.nDIpp span{font-weight:400}._2kIB-{font-style:italic;font-size:10px}._2kIB-,._2kIB- a{color:silver}._1j_P6{margin-left:20px}.G5EOs{width:100%}._3LiU5{width:50px;height:50px;cursor:pointer;margin:10px 10px 0 0}._2uAIc{position:relative;overflow:hidden;display:inline-block}._2uAIc input[type=file]{cursor:pointer;left:0;top:0;opacity:0}._2uAIc input[type=file],._3qbBX{position:absolute;width:100px;height:100px}._3qbBX{left:25px;top:20px;visibility:hidden;font-size:3em}._2uAIc:hover ._3qbBX{visibility:visible}._3LoqV{width:100px;height:100px;z-index:-1}._3LoqV img{position:absolute;margin:auto;top:0;left:0;right:0;bottom:0}._2uAIc:hover ._3LoqV{opacity:.2}._27u44{padding:0 0 10px}._2qOz-{margin:0 15px}._2qOz-,.pjBHr{display:-webkit-box;display:-ms-flexbox;display:flex}.pjBHr{margin-right:10px;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._1cZLr{margin:10px 0}.vMhAO{font-weight:700;margin:-22px 0 27px 55px}.vMhAO span{font-weight:400}", ""]);

// exports
exports.locals = {
	"title": "HTtFX",
	"topic": "nDIpp",
	"source": "_2kIB-",
	"listedItems": "_1j_P6",
	"currentImage": "G5EOs",
	"thumbnailImage": "_3LiU5",
	"uploadButtonWrapper": "_2uAIc",
	"glyphWrapper": "_3qbBX",
	"imageOverlay": "_3LoqV",
	"formComponent": "_27u44",
	"errorMessage": "_2qOz-",
	"alertIcon": "pjBHr",
	"youtube": "_1cZLr",
	"secondaryAge": "vMhAO"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-rules-2!./node_modules/postcss-loader/lib??ref--1-rules-3!./src/routes/activityView/ActivityView.css
// module id = 1464
// module chunks = 4